import { render, staticRenderFns } from "./relacaodedebitos.vue?vue&type=template&id=170098bd&"
import script from "./relacaodedebitos.vue?vue&type=script&lang=js&"
export * from "./relacaodedebitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports